import { css } from '@emotion/react';

export const container = css({
  position: 'relative',
  overflow: 'hidden',
  height: '462px'
});

export const scrollContainer = css({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row',
  columnGap: '32px',
  alignItems: 'flex-start',
  width: '1792px',
  transition: '.8s',
  willChange: 'transform'
});
